import { render, staticRenderFns } from "./pagec.vue?vue&type=template&id=3c1d1f9a&scoped=true"
import script from "./pagec.vue?vue&type=script&lang=js"
export * from "./pagec.vue?vue&type=script&lang=js"
import style0 from "./pagec.vue?vue&type=style&index=0&id=3c1d1f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d1f9a",
  null
  
)

export default component.exports